import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Area } from '../../../shared/models/area.interface';
import { GenericDialogData } from '../../models/generic.dialog.interface';
import { AreaEditComponent } from '../area-edit/area.edit.component';
import { SubareaComponent } from '../../subarea/subarea.component';
import { GenericPageTypes } from '../../enums/generic-page-types.enum';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SubArea } from '../../../shared/models/subarea.interface';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-area-list',
  templateUrl: './area-list.component.html',
  styleUrls: ['./area-list.component.scss']
})
export class AreaListComponent implements OnInit, OnDestroy {
  displayedColumns = ['subArea_Name', 'status'];

  areas: Area[];
  pagetypeEnum = GenericPageTypes;
  showActive: boolean = false;
  dealerId!: number;
  errors: string;


  private dealerSubscription: Subscription;

  constructor(private adminService: AdminService, private route: ActivatedRoute, public dialog: MatDialog, private snackBar: MatSnackBar) { }


  ngOnInit(): void {
    this.dealerSubscription = AdminService.impersonatedDealer$.subscribe(dealerId => {
      this.refreshAreas();
    });

    this.refreshAreas();
  }

  ngOnDestroy(): void {
    this.dealerSubscription.unsubscribe();
  }

  showAreaEdit(areaId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: areaId } as GenericDialogData;
    dialogConfig.width = '900px';

    const areaDialogRef = this.dialog.open(AreaEditComponent, dialogConfig);

    areaDialogRef.afterClosed().subscribe(result => {
      this.refreshAreas();
      console.log(`Dialog result: ${result}`);
    });
  }

  showSubAreaEdit(subAreaId) {
    const dialogSubAreaConfig = new MatDialogConfig();

    dialogSubAreaConfig.data = { id: subAreaId } as GenericDialogData;
    dialogSubAreaConfig.width = '900px';

    const subAreaDialogRef = this.dialog.open(SubareaComponent, dialogSubAreaConfig);

    subAreaDialogRef.afterClosed().subscribe(result => {
      this.refreshAreas();
      console.log(`Dialog result: ${result}`);
    });
  }

  toggleAreaFilter() {
    this.showActive = !this.showActive;
    this.refreshAreas();
  }

  toggleAreaStatus(page: string, id) {
    let dealerId = this.adminService.getDealerId();

    this.adminService.toggleStatus(page, id, dealerId)
      .subscribe(result => {
        console.log(result);
        if (result.id > 0) {
          this.areas.find(al => al.area_ID == id).area_IsActive = result.isActive;
        }
      });
  }

  toggleSubAreaStatus(page: string, areaId, subAreaId) {
    let dealerId = this.adminService.getDealerId();

    this.adminService.toggleStatus(page, subAreaId, dealerId)
      .subscribe(result => {
        console.log(result);
        if (result.id > 0) {
          let subArea_Area = this.areas.find(al => al.area_ID == areaId);
          subArea_Area.subAreas.find(sa => sa.subArea_ID == subAreaId).subArea_IsActive = result.isActive;
        }
      });
  }

  dropArea(event: CdkDragDrop<Area[]>) {
    let dealerId = this.adminService.getDealerId();

    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.adminService.resequenceAreas(dealerId,  event.container.data).subscribe({
        next: (data) => {
          this.refreshAreas();
        },
        error: (error: string) => {
                this.errors = error;
                console.log(this.errors);
                this.snackBar.open(this.errors, null, { duration: 4000, verticalPosition: 'bottom', panelClass: ['bidit-snackbar-alert'] });
              }
      });
    }
  }

  dropSubArea(areaId: number, event: CdkDragDrop<SubArea[]>) {
    if (event.previousIndex !== event.currentIndex) {
      let dealerId = this.adminService.getDealerId();

      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.adminService.resequenceSubAreas(areaId, dealerId, event.container.data).subscribe({
        next: (data) => {
          this.refreshAreas();
        },
        error: (error: string) => {
          this.errors = error;
          console.log(this.errors);
          this.snackBar.open(this.errors, null, { duration: 4000, verticalPosition: 'bottom', panelClass: ['bidit-snackbar-alert'] });
        }
      });
    }
  }


  refreshAreas() {
    let dealerId = this.adminService.getDealerId();
    this.adminService.getAreaList(dealerId)
      .subscribe({
        next: (data) => {
          const filtered = data.filter(d => d.area_IsActive || this.showActive);

          this.areas = filtered;

          this.areas.forEach(a => {
            a.subAreas = a.subAreas.filter(d => d.subArea_IsActive || this.showActive);
          });
        }
      });
  }
}
